import { createBrowserHistory } from "history";
export default createBrowserHistory();


// WEBPACK FOOTER //
// ./src/services/AIservice/AIservice.js